import { NgFor } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FocusManagerService } from '@sc/feature-focus-manager';

export interface FastNavLink {
  id?: string;
  target: string;
  textKey: string;
  textOptions?: Object;
}

@Component({
  selector: 'sc-fast-access-tab-menu',
  styleUrls: ['./fast-access-tab-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgFor, RouterLink, TranslateModule],
  template: `
    <ul class="fast-nav-link-list">
      <ng-container *ngFor="let link of linkList">
        <li>
          <a
            [id]="link.id"
            [class.keep-absolute]="keepAbsolute"
            [routerLink]="['.']"
            queryParamsHandling="preserve"
            [fragment]="link.target"
            [innerHTML]="link.textKey | translate: link.textOptions"
            (click)="onLinkClick(link.target)"
          ></a>
        </li>
      </ng-container>
    </ul>
  `,
})
export class FastAccessTabMenuComponent {
  @Input() linkList: FastNavLink[] = [];
  @Input() keepAbsolute = true;

  constructor(private readonly focusManager: FocusManagerService) {}

  onLinkClick(linkId: string) {
    this.focusManager.moveFocusStartingPoint(`#${linkId}`);
  }
}
